export class HybrisNameHandler {
  static getFirstName(name: string): string {
    return name.split(' ')[0];
  }

  static getLastName(name: string): string {
    const names = name.split(' ');
    if (names.length > 1) {
      return names.slice(1, name.length).join(' ');
    }
    return '';
  }

  static getName(firstName: string, lastName: string): string {
    return firstName + ' ' + lastName;
  }
}
